// @flow
import * as React from 'react';

export const Missing = () => {
  return (
    <>
      <p>
        This command is only supported by the locally installed Stripe CLI. To
        <br />
        install and get started with the local Stripe CLI, run `cd ~/stripe-cli`
        <br />
        in the Stripe Shell to view download instructions.
      </p>
      <br />
      <p>
        If you think we should implement this command (or any other ones),
        <br />
        please leave us feedback through the `feedback` command.
      </p>
    </>
  );
};
